import { render, staticRenderFns } from "./PurchaseTokens.vue?vue&type=template&id=3171d248&"
import script from "./PurchaseTokens.vue?vue&type=script&lang=js&"
export * from "./PurchaseTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports